import { useCallback, useEffect, useRef, useState } from "react"

const useGeolocation = () => {
  const [location, setLocation] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const isMountedRef = useRef(true)

  const handleSuccess = useCallback((position) => {
    if (!isMountedRef.current) return

    const { latitude, longitude } = position.coords
    setLocation({ latitude, longitude })
    setLoading(false)
  }, [])

  const handleError = useCallback((error) => {
    if (!isMountedRef.current) return

    setError(error.message)
    setLoading(false)
  }, [])

  const refetch = useCallback(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by this browser.")
      return
    }

    setLoading(true)
    setError(null)

    navigator.geolocation.getCurrentPosition(handleSuccess, handleError)
  }, [handleSuccess, handleError])

  useEffect(() => {
    refetch()

    return () => {
      isMountedRef.current = false
    }
  }, [refetch])

  return { location, error, loading, refetch }
}

export default useGeolocation
